import React from 'react';
import { Box } from '@mui/material';
import LoadingBook from '../LoadingBook';

type LoadingBookOverlayProps = {
  contained?: boolean;
  withinParent?: boolean;
  label?: string;
};

const LoadingBookOverlay: React.FC<LoadingBookOverlayProps> = ({
  contained = true,
  withinParent = false,
  label = 'Loading',
}) => {
  const dashboardLeftInset = 'var(--fable-dashboard-modal-left, 0px)';
  const dashboardRightInset = 'var(--fable-dashboard-modal-right, 0px)';
  const dashboardTopInset = 'var(--fable-dashboard-modal-top, 0px)';

  return (
    <Box
      role="status"
      aria-live="polite"
      aria-label={label}
      sx={{
        position: withinParent ? 'absolute' : 'fixed',
        top: withinParent ? 0 : contained ? dashboardTopInset : 0,
        left: withinParent ? 0 : contained ? dashboardLeftInset : 0,
        right: withinParent ? 0 : contained ? dashboardRightInset : 0,
        bottom: 0,
        // Stay above confirmation dialogs once an async action starts, while
        // the contained insets keep the dashboard header and drawers exposed.
        zIndex: withinParent ? 10 : contained ? 1350 : 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'rgba(8,10,16,0.86)',
        backdropFilter: 'blur(4px)',
        transition: 'top 0.22s ease, left 0.22s ease, right 0.22s ease',
      }}
    >
      <LoadingBook />
    </Box>
  );
};

export default LoadingBookOverlay;
